import { StIcon } from "@core/components/icons";
import { A } from "@solidjs/router";
import { TbCircleCheck } from "solid-icons/tb";
import { For, Show, createSignal } from "solid-js";

export const Footer = () => {
  const keyInfo = [
    {
      link: "https://storytell.ai",
      label: "Home",
    },
    { link: "https://web.storytell.ai/prompts", label: "AI Prompt Library" },
    {
      link: "https://web.storytell.ai/about-us",
      label: "About",
    },
    {
      link: "https://web.storytell.ai/careers",
      label: "Careers",
    },
  ];
  const storytellFor = [
    {
      label: "Product Managers",
      link: "https://web.storytell.ai/prompts/product-manager",
    },
    {
      label: "Technical Writers",
      link: "https://web.storytell.ai/prompts/technical-writer",
    },
    {
      label: "Market Analysts",
      link: "https://web.storytell.ai/prompts/marketing-analyst",
    },
    {
      label: "Market Intelligence",
      link: "https://web.storytell.ai/prompts/market-intelligence",
    },
    {
      label: "Content Marketers",
      link: "https://web.storytell.ai/prompts/content-marketer",
    },
    {
      label: "Customer Success Managers",
      link: "https://web.storytell.ai/prompts/customer-success-manager",
    },
  ];

  const resources = [
    {
      label: "Blog",
      link: "https://web.storytell.ai/blog",
    },
    {
      label: "Webinars & Workshops",
      link: "https://web.storytell.ai/webinars",
    },
    {
      label: "Privacy Policy",
      link: "https://web.storytell.ai/privacy-policy",
    },
    {
      label: "Cookie Policy",
      link: "https://web.storytell.ai/cookie-policy",
    },
    {
      label: "Trust Center",
      link: "https://trust.storytell.ai/",
    },
  ];

  const support = [
    {
      link: "http://docs.storytell.ai/",
      label: "Documentation",
    },
    {
      link: "https://status.storytell.ai/",
      label: "System Status",
    },
    {
      link: "https://web.storytell.ai/contact",
      label: "Contact Us",
    },
  ];

  return (
    <footer
      class="bg-[#070b24] dark:from-transparent dark:to-transparent dark:border-t dark:border-white/5 pb-32"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" class="sr-only">
        Footer
      </h2>
      <div class="mx-auto max-w-7xl px-6 pb-8 pt-20 sm:pt-24 lg:px-8 lg:pt-32">
        <div class="xl:grid xl:grid-cols-3 xl:gap-8">
          <div class="grid grid-cols-4 gap-8 xl:col-span-2">
            <div class="col-span-4 sm:grid sm:grid-cols-2 md:grid-cols-4 md:col-span-4 md:gap-8">
              <div class="mt-10 md:mt-0">
                <h3 class="text-sm font-semibold leading-6 text-white">Key Info</h3>
                <ul class="mt-6 space-y-4">
                  <For each={keyInfo}>
                    {(item) => (
                      <li>
                        <a href={item.link} class="text-sm leading-6 text-gray-300 hover:text-white">
                          {item.label}
                        </a>
                      </li>
                    )}
                  </For>
                </ul>
              </div>
              <div class="mt-10 md:mt-0">
                <h3 class="text-sm font-semibold leading-6 text-white">Storytell For</h3>
                <ul class="mt-6 space-y-4">
                  <li>
                    <A href="/work" class="text-sm leading-6 text-gray-300 hover:text-white">
                      Work
                    </A>
                  </li>
                  <For each={storytellFor}>
                    {(item) => (
                      <li class="pl-4">
                        <a href={item.link} class="text-sm leading-6 text-gray-300 hover:text-white">
                          {item.label}
                        </a>
                      </li>
                    )}
                  </For>

                  <li>
                    <A href="/life" class="text-sm leading-6 text-gray-300 hover:text-white">
                      Life
                    </A>
                  </li>
                  <li>
                    <A href="/play" class="text-sm leading-6 text-gray-300 hover:text-white">
                      Play
                    </A>
                  </li>
                </ul>
              </div>
              <div class="mt-10 md:mt-0">
                <h3 class="text-sm font-semibold leading-6 text-white">Content</h3>
                <ul class="mt-6 space-y-4">
                  <For each={resources}>
                    {(item) => (
                      <li>
                        <a href={item.link} class="text-sm leading-6 text-gray-300 hover:text-white">
                          {item.label}
                        </a>
                      </li>
                    )}
                  </For>
                </ul>
              </div>
              <div class="mt-10 md:mt-0">
                <h3 class="text-sm font-semibold leading-6 text-white">Support</h3>
                <ul class="mt-6 space-y-4">
                  <For each={support}>
                    {(item) => (
                      <li>
                        <a href={item.link} class="text-sm leading-6 text-gray-300 hover:text-white">
                          {item.label}
                        </a>
                      </li>
                    )}
                  </For>
                </ul>
              </div>
            </div>
          </div>
          <div class="mt-10 xl:mt-0">
            <h3 class="text-sm font-semibold leading-6 text-white">Subscribe to our newsletter</h3>
            <p class="mt-2 text-sm leading-6 text-gray-300">
              Learn how we’re shaping our product in response to the rapidly changing landscape of AI
            </p>
            <NewsletterForm />

            <div class="h-10" aria-hidden />

            <div class="flex justify-end gap-2">
              <a class="w-32" href="https://trust.storytell.ai" target="_blank" rel="noreferrer">
                <img src="/images/home/Vanta_Compliance_SOC2.avif" alt="SOC2 Compliant - Powered by Vanta" />
              </a>
              <a class="w-32" href="https://trust.storytell.ai" target="_blank" rel="noreferrer">
                <img src="/images/home/Vanta_Compliance_HIPAA.png" alt="HIPAA Compliant - Powered by Vanta" />
              </a>
              <a class="w-32" href="https://trust.storytell.ai" target="_blank" rel="noreferrer">
                <img src="/images/home/Vanta_Compliance_GDPR.png" alt="GDPR Compliant - Powered by Vanta" />
              </a>
            </div>
          </div>
        </div>
        <div class="mt-8 border-t border-white/10 pt-8 sm:mt-20 md:flex md:items-center md:justify-between lg:mt-24">
          <div class="flex space-x-6 md:order-2">
            <a
              href="https://www.facebook.com/storytellai"
              target="_blank"
              class="text-gray-500 hover:text-gray-400"
              rel="noreferrer"
            >
              <div class="h-6 w-6">
                <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22 12.0611C22 6.50451 17.5229 2 12 2C6.47715 2 2 6.50451 2 12.0611C2 17.0828 5.65684 21.2452 10.4375 22V14.9694H7.89844V12.0611H10.4375V9.84452C10.4375 7.32296 11.9305 5.93012 14.2146 5.93012C15.3088 5.93012 16.4531 6.12663 16.4531 6.12663V8.60261H15.1922C13.95 8.60261 13.5625 9.37822 13.5625 10.1739V12.0611H16.3359L15.8926 14.9694H13.5625V22C18.3432 21.2452 22 17.083 22 12.0611Z"
                    fill="CurrentColor"
                  />
                </svg>
              </div>
              <div class="sr-only">Facebook</div>
            </a>
            <a
              href="https://www.instagram.com/storytell_ai/"
              target="_blank"
              class="text-gray-500 hover:text-gray-400"
              rel="noreferrer"
            >
              <div class="h-6 w-6">
                <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 3H8C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21H16C18.7614 21 21 18.7614 21 16V8C21 5.23858 18.7614 3 16 3ZM19.25 16C19.2445 17.7926 17.7926 19.2445 16 19.25H8C6.20735 19.2445 4.75549 17.7926 4.75 16V8C4.75549 6.20735 6.20735 4.75549 8 4.75H16C17.7926 4.75549 19.2445 6.20735 19.25 8V16ZM16.75 8.25C17.3023 8.25 17.75 7.80228 17.75 7.25C17.75 6.69772 17.3023 6.25 16.75 6.25C16.1977 6.25 15.75 6.69772 15.75 7.25C15.75 7.80228 16.1977 8.25 16.75 8.25ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5027 10.8057 16.0294 9.65957 15.1849 8.81508C14.3404 7.97059 13.1943 7.49734 12 7.5ZM9.25 12C9.25 13.5188 10.4812 14.75 12 14.75C13.5188 14.75 14.75 13.5188 14.75 12C14.75 10.4812 13.5188 9.25 12 9.25C10.4812 9.25 9.25 10.4812 9.25 12Z"
                    fill="CurrentColor"
                  />
                </svg>
              </div>
              <div class="sr-only">Instagram</div>
            </a>
            <a
              href="https://twitter.com/storytell_ai"
              target="_blank"
              class="text-gray-500 hover:text-gray-400"
              rel="noreferrer"
            >
              <div class="h-6 w-6">
                <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.1761 4H19.9362L13.9061 10.7774L21 20H15.4456L11.0951 14.4066L6.11723 20H3.35544L9.80517 12.7508L3 4H8.69545L12.6279 9.11262L17.1761 4ZM16.2073 18.3754H17.7368L7.86441 5.53928H6.2232L16.2073 18.3754Z"
                    fill="CurrentColor"
                  />
                </svg>
              </div>
              <div class="sr-only">X</div>
            </a>
            <a
              href="https://www.linkedin.com/company/storytell-ai/"
              target="_blank"
              class="text-gray-500 hover:text-gray-400"
              rel="noreferrer"
            >
              <div class="h-6 w-6">
                <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.5 3C3.67157 3 3 3.67157 3 4.5V19.5C3 20.3284 3.67157 21 4.5 21H19.5C20.3284 21 21 20.3284 21 19.5V4.5C21 3.67157 20.3284 3 19.5 3H4.5ZM8.52076 7.00272C8.52639 7.95897 7.81061 8.54819 6.96123 8.54397C6.16107 8.53975 5.46357 7.90272 5.46779 7.00413C5.47201 6.15897 6.13998 5.47975 7.00764 5.49944C7.88795 5.51913 8.52639 6.1646 8.52076 7.00272ZM12.2797 9.76176H9.75971H9.7583V18.3216H12.4217V18.1219C12.4217 17.742 12.4214 17.362 12.4211 16.9819V16.9818V16.9816V16.9815V16.9812C12.4203 15.9674 12.4194 14.9532 12.4246 13.9397C12.426 13.6936 12.4372 13.4377 12.5005 13.2028C12.7381 12.3253 13.5271 11.7586 14.4074 11.8979C14.9727 11.9864 15.3467 12.3141 15.5042 12.8471C15.6013 13.1803 15.6449 13.5389 15.6491 13.8863C15.6605 14.9339 15.6589 15.9815 15.6573 17.0292V17.0294C15.6567 17.3992 15.6561 17.769 15.6561 18.1388V18.3202H18.328V18.1149C18.328 17.6629 18.3278 17.211 18.3275 16.7591V16.759V16.7588C18.327 15.6293 18.3264 14.5001 18.3294 13.3702C18.3308 12.8597 18.276 12.3563 18.1508 11.8627C17.9638 11.1286 17.5771 10.5211 16.9485 10.0824C16.5027 9.77019 16.0133 9.5691 15.4663 9.5466C15.404 9.54401 15.3412 9.54062 15.2781 9.53721L15.2781 9.53721L15.2781 9.53721C14.9984 9.52209 14.7141 9.50673 14.4467 9.56066C13.6817 9.71394 13.0096 10.0641 12.5019 10.6814C12.4429 10.7522 12.3852 10.8241 12.2991 10.9314L12.2991 10.9315L12.2797 10.9557V9.76176ZM5.68164 18.3244H8.33242V9.76733H5.68164V18.3244Z"
                    fill="CurrentColor"
                  />
                </svg>
              </div>
              <div class="sr-only">LinkedIn</div>
            </a>
            <a
              href="https://www.youtube.com/@storytell_ai"
              target="_blank"
              class="text-gray-500 hover:text-gray-400"
              rel="noreferrer"
            >
              <div class="h-6 w-6">
                <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.5686 4.77345C21.5163 5.02692 22.2555 5.76903 22.5118 6.71673C23.1821 9.42042 23.1385 14.5321 22.5259 17.278C22.2724 18.2257 21.5303 18.965 20.5826 19.2213C17.9071 19.8831 5.92356 19.8015 3.40294 19.2213C2.45524 18.9678 1.71595 18.2257 1.45966 17.278C0.827391 14.7011 0.871044 9.25144 1.44558 6.73081C1.69905 5.78311 2.44116 5.04382 3.38886 4.78753C6.96561 4.0412 19.2956 4.282 20.5686 4.77345ZM9.86682 8.70227L15.6122 11.9974L9.86682 15.2925V8.70227Z"
                    fill="CurrentColor"
                  />
                </svg>
              </div>
              <div class="sr-only">Youtube</div>
            </a>
            <a
              href="https://www.tiktok.com/@storytell.ai?lang=en"
              target="_blank"
              class="text-gray-500 hover:text-gray-400"
              rel="noreferrer"
            >
              <div class="h-6 w-6">
                <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9974 9.34865 20.9429 6.80665 19.0681 4.93186C17.1934 3.05707 14.6514 2.00265 12 2ZM17.939 9.713V10.359C17.939 10.4084 17.9291 10.4574 17.9099 10.5029C17.8907 10.5485 17.8625 10.5897 17.8271 10.6242C17.7917 10.6587 17.7497 10.6858 17.7037 10.7038C17.6576 10.7218 17.6084 10.7303 17.559 10.729C16.5032 10.6542 15.4932 10.2687 14.656 9.621V14.349C14.6559 14.8723 14.5515 15.3903 14.3489 15.8728C14.1463 16.3553 13.8495 16.7925 13.476 17.159C13.0991 17.5346 12.6513 17.8315 12.1586 18.0324C11.6658 18.2333 11.1381 18.3341 10.606 18.329C9.53594 18.3271 8.50894 17.9073 7.744 17.159C7.2574 16.6684 6.9069 16.0596 6.727 15.3924C6.5471 14.7252 6.544 14.0227 6.718 13.354C6.877 12.712 7.198 12.122 7.651 11.641C7.98883 11.2281 8.41468 10.8959 8.8974 10.6687C9.38012 10.4416 9.90751 10.3251 10.441 10.328H11.261V12.031C11.2614 12.0805 11.2512 12.1294 11.2311 12.1746C11.2111 12.2199 11.1816 12.2603 11.1447 12.2932C11.1078 12.3261 11.0643 12.3508 11.0171 12.3656C10.9699 12.3804 10.9201 12.385 10.871 12.379C10.3949 12.236 9.88186 12.2834 9.44004 12.5113C8.99822 12.7392 8.66214 13.1297 8.50265 13.6006C8.34315 14.0714 8.37269 14.5858 8.58505 15.0353C8.79742 15.4847 9.176 15.8342 9.641 16.01C9.911 16.165 10.213 16.256 10.523 16.277C10.763 16.287 11.003 16.257 11.231 16.185C11.6118 16.0568 11.943 15.8129 12.1784 15.4873C12.4138 15.1618 12.5417 14.7708 12.544 14.369V5.754C12.5439 5.70677 12.5531 5.65998 12.571 5.61631C12.589 5.57264 12.6154 5.53294 12.6488 5.4995C12.6821 5.46606 12.7218 5.43953 12.7654 5.42142C12.809 5.40332 12.8558 5.394 12.903 5.394H14.318C14.41 5.39387 14.4986 5.42907 14.5654 5.49234C14.6322 5.55561 14.6721 5.64212 14.677 5.734C14.7288 6.17518 14.869 6.60139 15.0892 6.98714C15.3095 7.37288 15.6053 7.71023 15.959 7.979C16.4371 8.33789 17.0049 8.55796 17.6 8.615C17.6891 8.62262 17.7725 8.66228 17.8346 8.72663C17.8968 8.79098 17.9335 8.87566 17.938 8.965L17.939 9.713Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div class="sr-only">TikTok</div>
            </a>
          </div>
          <p class="mt-8 text-xs leading-5 text-gray-400 md:order-1 md:mt-0">
            &copy; {new Date().getFullYear()} Storytell.ai. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

const NewsletterForm = () => {
  const [email, setEmail] = createSignal("");
  const [error, setError] = createSignal("");
  const [submitted, setSubmitted] = createSignal(false);

  function handleSubmit(e: SubmitEvent) {
    e.preventDefault();
    const formBody = `email=${encodeURIComponent(email())}&userGroup=Gen%202%20Newsletter`;

    // Change this URL to your own endpoint URL
    fetch("https://app.loops.so/api/newsletter-form/clrzbbzjc00s814piehebtfwl", {
      method: "POST",
      body: formBody,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((r) => r.json())
      .then((r: { success: boolean; message?: string }) => {
        if (r.success) {
          setSubmitted(true);
        } else {
          setSubmitted(false);
          setError(r.message || "");
        }
      });
  }

  return (
    <Show
      when={!submitted()}
      fallback={
        <div class="mt-6 sm:flex sm:max-w-md text-white flex items-center gap-2">
          <StIcon icon={TbCircleCheck} />
          Thanks! We'll be in touch!
        </div>
      }
    >
      <div>
        <form class="mt-6 sm:flex sm:max-w-md" onSubmit={handleSubmit}>
          <label for="email-address" class="sr-only">
            Email address
          </label>
          <input
            type="email"
            name="email-address"
            id="email-address"
            autocomplete="email"
            onInput={(e) => setEmail(e.target.value)}
            required
            class="w-full min-w-0 appearance-none rounded-md border-0 bg-white/5 px-3 py-1.5 text-base text-white shadow-sm ring-1 ring-inset ring-white/10 placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:w-64 sm:text-sm sm:leading-6 xl:w-full"
            placeholder="Enter your email"
          />
          <div class="mt-4 sm:ml-4 sm:mt-0 sm:flex-shrink-0">
            <button
              type="submit"
              class="flex w-full items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-indigo-800 shadow-sm hover:bg-indigo-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
            >
              Subscribe
            </button>
          </div>
        </form>
        <div class="text-red-300 mt-3">{error()}</div>
      </div>
    </Show>
  );
};
